// import { dashCaseToCamelCase } from '@angular/compiler/src/util';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './layouts/default/default.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { DeviceComponent } from './modules/device/device.component';
import { HelpComponent } from './modules/help/help.component';
import { LoginComponent } from './modules/login/login.component';
import { RedliningComponent } from './modules/redlining/redlining.component';
import { RegionComponent } from './modules/region/region.component';
import { SettingComponent } from './modules/setting/setting.component';
import { UserComponent } from './modules/user/user.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LogComponent } from './modules/log/log.component';
import { ConfigurationComponent } from './modules/configuration/configuration.component';
import { DbprecacheComponent } from './modules/configuration/dbprecache/dbprecache.component';
import { CachingSettingsComponent } from './modules/region/cachingsettings/cachingsettings.component';

const routes: Routes = [
  {
    path: 'default',
    component: DefaultComponent,
    children: [
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'user/:id',
        component: UserComponent,
      },
      {
        path: 'region/:id',
        component: RegionComponent,
      },
      {
        path: 'device/:id',
        component: DeviceComponent,
      },
      {
        path: 'redlining',
        component: RedliningComponent,
      },
      {
        path: 'setting',
        component: SettingComponent,
      },
      {
        path: 'config',
        component: ConfigurationComponent,
      },
      {
        path: 'help',
        component: HelpComponent,
      },
      {
        path: 'log',
        component: LogComponent,
      },
      {
        path: 'dbprecache',
        component: DbprecacheComponent,
      },
      {
        path: 'cachingsettings',
        component: CachingSettingsComponent,
      }
    ],
   },
  {
    path: '',
    component: LoginComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
})
export class AppRoutingModule {}
